"use client";
import ArrowSwiperWithInfoSection, {
  ArrowSwiperWithInfoProps,
} from "@cc/arrow-swiper-with-info-section";
import ArrowSlideInfo from "@cc/cards/arrow-slide-info";

import { H3_2 } from "@theme/components/typography.fontvariant";
import React from "react";
import { ArrowSlideDefaultImageProps } from "@cc/cards/arrow-slide-default-image";

export interface WhatsHappeningSectionProps {
  title?: string;
  data: (ArrowSwiperWithInfoProps<
    typeof ArrowSlideInfo
  >["data"][number]["data"][number] &
    ArrowSlideDefaultImageProps)[];
  navId?: string;
}

const WhatsHappeningSection = (props: WhatsHappeningSectionProps) => {
  const { title, data, navId } = props;
  return (
    <ArrowSwiperWithInfoSection
      data={data}
      SwiperKey={WhatsHappeningSection.name}
      SectionWrapperProps={{
        navId: navId || `what's-new`,
        color: "secondary.main",
        SectionProps: {
          bgcolor: "primary.main",
        },
        SectionHeaderProps: {
          title
        },
      }}
      SwiperProps={{
        navigation: true,
      }}
      ArrowSlideInfoProps={{
        SlotProps: {
          TitleTypographyProps: {
            fontSize: H3_2,
          },
        },
      }}
    />
  );
};

export default WhatsHappeningSection;
